import {
  Box,
  Grid2,
  Paper,
  TextField,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormStyles } from "../../../hooks";
import { LithologyPreview } from "../../../types/interfaces/file/imports/lithologies";

interface UploadLithologyFormProps {
  lithology: LithologyPreview;
  lithologyName: string;
  secondaryFeatureName: string;
  textureName: string;
  colorName: string;
  aquiferName: string;
}

export const UploadLithologyForm = ({
  lithology,
  lithologyName,
  secondaryFeatureName,
  textureName,
  colorName,
  aquiferName
}: UploadLithologyFormProps) => {
  const { t } = useTranslation();
  const formStyles = useFormStyles(true);

  return (
    <Box>
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("captures.capture.lithology.title")}
            </Typography>
            <Grid2 container spacing={2}>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.start-depth")}
                  value={lithology.startDepth}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.depth-measurement.end-depth")}
                  value={lithology.endDepth}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.lithology-type")}
                  value={lithologyName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.aquifer-system")}
                  value={aquiferName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.hydraulic-conductivity")}
                  value={lithology.hydraulicConductivity}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.secondary-feature")}
                  value={secondaryFeatureName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.texture")}
                  value={textureName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.color")}
                  value={colorName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={12}>
                <TextField
                  fullWidth
                  label={t("captures.capture.lithology.notes")}
                  value={lithology.notes ?? ""}
                  disabled
                  multiline
                  minRows={3}
                  sx={{ ...formStyles }}
                />
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>
      </Grid2>
    </Box>
  );
};